import { ComponentProps, useState, useEffect, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { VariantProps } from 'tailwind-variants';
import { useCoursesStore } from '../../../../../modules/Courses/stores/courseStore';
import { getDisciplineName } from '../../../../utils/discipline';
import { Chip } from '../../../atoms/Chip';
import { Icon } from '../../../atoms/Icon';
import { Typography } from '../../../molecules/Typography';
import { InfoLine, IconContainer } from '../variants';
import Logo from '../../../../../assets/images/brand/logo-black.png';

interface IPaperHeader extends VariantProps<typeof InfoLine> {
  icon: {
    iconType: 'material' | 'svg';
    icon: React.ComponentType<ComponentProps<'svg'>> | string;
  };
  module: string;
  title: string;
}

//Cores fixas para funcionar na impressão
export default function PaperHeader({
  icon,
  color,
  module,
  title,
}: IPaperHeader) {
  const url = useLocation();

  const [isCourse, setIsCourse] = useState<boolean>(false);
  const [course, setCourse] = useState<string>('');
  const [weekCourse, setWeekCourse] = useState<string>('');

  useEffect(() => {
    if (url.pathname.includes('cursos')) {
      const selectedCourse = useCoursesStore.getState().loadedCourse;

      if (selectedCourse) {
        setIsCourse(true);
        setCourse(selectedCourse.title);
        setWeekCourse(selectedCourse.selectedProgramObject.title);
      }
    }
  }, [url]);

  return (
    <Fragment>
      <div className='flex flex-row items-end justify-between px-5 pt-2'>
        <div className={IconContainer({ color })}>
          <Icon
            type={icon.iconType}
            Icon={icon.icon}
            className='h-7 w-7 fill-[#fff]'
          />
        </div>
        <img src={Logo} className='mb-1' />
      </div>
      <div className={InfoLine({ color })}>
        <div className='flex flex-row items-center gap-lg'>
          <Typography className='text-[#fff]'>
            {getDisciplineName(module)}
          </Typography>
          <Chip
            variant='filled'
            radius='pill'
            className='bg-[#000]/15 border-none py-2'
          >
            <Typography className='text-[#fff]' weight='bold'>
              {title}
            </Typography>
          </Chip>
        </div>
        {isCourse && (
          <div className='flex flex-row items-center gap-lg'>
            <Typography className='text-[#fff]'>{course}</Typography>
            <Typography className='text-[#fff]'>{weekCourse}</Typography>
          </div>
        )}
      </div>
    </Fragment>
  );
}
